import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    subscription: state.pages.productDetails.subscription,
});

export interface ProductDetailsAddToCartButtonStyles {
    button?: ButtonPresentationProps;
}

export const addToCartButtonStyles: ProductDetailsAddToCartButtonStyles = {
    button: {
        css: css`
            width: 100%;
            min-height: 40px;
            font-size: 16px !important;
            font-weight: 600;
            border-color: #FFA41C !important;
            background: #FFD812 !important;
            color: #000000 !important;
            text-transform: capitalize;
            > span {
                font-size: 16px;
                width: 20px;
                height: 20px;
                > svg {
                    width: 20px;
                    height: 20px;
                }
            }

            &:disabled {
                color: #fff !important;
                border-color: #cccccc !important;
                background: #cccccc !important;
                > span {
                    color: #fff !important;
                    font-weight: unset !important;
                }
            }
            &:hover {
                background: #FFA41C !important;
                box-shadow: 0 2px 5px 0 #d5d9d980;
            }
        `,
    },
};

const styles = addToCartButtonStyles;

const ProductDetailsAddToCartButton = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    subscription,
    product,
}: Props) => {
    const callForPricing = product.properties?.isCallForPricing?.toLowerCase() === "true";

    return (
        <>
            {!callForPricing && (
                <ProductAddToCartButton
                    configurationSelection={configurationSelection}
                    configurationCompleted={configurationCompleted}
                    variantSelectionCompleted={variantSelectionCompleted}
                    subscription={subscription}
                    extendedStyles={styles.button}
                    data-test-selector="addProductToCart"
                />
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsAddToCartButton)),
    definition: {
        displayName: "Add to Cart Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
